
import React, { useEffect, useRef, useState } from 'react';

import { usePromise } from '@infonova/framework/lib/react/hooks/usePromise';
import { serviceResolver } from '@infonova/framework/lib/service/configuration/serviceResolver';

import TreeMenu from 'react-simple-tree-menu';

import { ServiceConfiguration } from "../../configuration/ServicesConfiguration";

import { useClickOutside } from './useClickOutside'
import { Pagination } from 'src/app/configuration/types/Pagination';

// import default minimal styling or your own styling
// import '../../../../node_modules/react-simple-tree-menu/dist/main.css';
// Use the default minimal UI
// https://iannbing.github.io/react-simple-tree-menu/?path=/story/treemenu--default-usage

const treeData = [
  {
    key: 'first-level-node-1',
    label: 'Node 1 at the first level',
    nodes: [
      {
        key: 'second-level-node-1',
        label: 'Node 1 at the second level',
        nodes: [
          {
            key: 'third-level-node-1',
            label: 'Last node of the branch',
            nodes: [] // you can remove the nodes property or leave it as an empty array
          },
        ],
      },
    ],
  },
  {
    key: 'first-level-node-2',
    label: 'Node 2 at the first level',
  },
];

type OrganizationComponentProps = {
  id: string,
  callback: (evt: any) => void
};

const OrganizationComponent = (props: OrganizationComponentProps) => {
  const ref = useRef<HTMLDivElement>(null)
  /** Clear error if id has changed */
  const customerAccountService = useState(() => serviceResolver().getService(ServiceConfiguration.CustomerAccountRelationshipService))[0];
  // Get address from service and reload everytime the id changes.

  const [customerAccountId, setCustomerAccountId] = useState(null);
  const [customerAccountList, setCustomerAccountList] = useState({});
  const [orgHierarchy, setOrgHierarchy] = useState({});
  const [page, setPage] = useState(1);

  useEffect(() => {
    setCustomerAccountId(props.id);
  }, []);


  const onClickOutside = (event: MouseEvent) => {
    // setOpen(false);
    if ((event.target as Element).classList.contains('rstm-tree-item')
    || (event.target as Element).classList.contains('navigationBtn')) {
      return;
    }
    props.callback(null);
  }

  useClickOutside(ref, onClickOutside);


  const findTradingName = async (id: string) => {
    const customerAccount = await customerAccountService.getCustomerAccount(id);

    const organizationParties = customerAccount.relatedParties.filter(party => party.type == "Organization");
    if (organizationParties.length > 0) {
      const party = await customerAccountService.getPartyOrganization(organizationParties[0].party);
      return party.tradingName;
    }

    return id;
  }

  useEffect(() => {
    const fetchRelationshipsRoot = async () => {
      if (!customerAccountId) {
        const pagination: Pagination = {
          page: page,
          pageSize: 20
        }

        const customerAcounts = await customerAccountService.getCustomerAccounts(pagination);
        const customerTree = [];
        for (let customerAccount of customerAcounts.list) {
          let name = customerAccount.organization?.tradingName;
          if (!name) {
            name = (customerAccount as any).individual.givenName + ' ' +  (customerAccount as any).individual.familyName;
          }
          customerTree.push({
            key: customerAccount.id,
            label: name,
            nodes: []
          });
        }

        setCustomerAccountList(customerTree);
      } else {
        let relationships = await customerAccountService.getCustomerAccountRelationships(customerAccountId);
        let rootCustomerAccountId = customerAccountId;
        while (true) {
          for (let relationship of relationships.list.filter(relationship => relationship.type == 'Parent')) {
            rootCustomerAccountId = relationship.relatedCustomerAccount;
            relationships = await customerAccountService.getCustomerAccountRelationships(rootCustomerAccountId);
            continue;
          }
          break;
        }

        const tree = [await fetchRelationship(rootCustomerAccountId)];

        setOrgHierarchy(tree);
      }
    };

    fetchRelationshipsRoot();
  }, [page, customerAccountId]);

  const fetchRelationship = async (id: string) => {
    const nodes = [];

    const relationships = await customerAccountService.getCustomerAccountRelationships(id);

    for (let relationship of relationships.list.filter(relationship => relationship.type == 'Child')) {
      nodes.push(await fetchRelationship(relationship.relatedCustomerAccount))
    }

    return {
      key: id,
      label: await findTradingName(id),
      nodes: nodes
    }
  }

  const selectCustomerAccount = (evt) => {
    setCustomerAccountId(evt.key);
  }

  const navigateBackPage = (evt) => {
    if (page > 1) {
      setPage(page - 1);
    }
  }

  const navigateFwdPage = (evt) => {
    setPage(page + 1);
  }


  {/* @ts-ignore */ }
  return <div ref={ref} style={{ minHeight: "50rem" }} >
    {!customerAccountId &&
      <div>
        <div className="customerAccountBar">
          <div className="accountLabel">Choose Customer Account:</div>
          <div className="navigationBtn" style={{ marginRight: "1rem" }} onClick={navigateBackPage}>&#9664; Previous</div>
          <div className="navigationBtn" onClick={navigateFwdPage}>Next &#9654;</div>
        </div>
        <TreeMenu data={customerAccountList} onClickItem={selectCustomerAccount} />
      </div>
    }
    {customerAccountId && 
          <div>
            <div className="customerAccountBar">
              <div className="accountLabel">Choose Billing Account:</div>
            </div>
            <TreeMenu data={orgHierarchy} onClickItem={props.callback} />
          </div>
    }
  </div>
};

export { OrganizationComponent };